/* Evento Lead (Meta Pixel) + generate_lead (dataLayer -> GA4 via GTM).
   Si attiva solo dopo la conferma di invio del modulo e solo con consenso prestato.
   Deduplica: lo stesso eventId non viene mai inviato due volte (doppio clic,
   ricarica della pagina, nuovo invio dello stesso lead). */
const PENDING_KEY = "sc_pending_lead_id";
const SENT_KEY = "sc_sent_lead_ids";

const read = (key, fallback) => {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : fallback;
  } catch (e) {
    return fallback;
  }
};

/** Id stabile per questo tentativo di invio: sopravvive a doppio clic e ricarica. */
export const getLeadEventId = () => {
  try {
    const existing = localStorage.getItem(PENDING_KEY);
    if (existing) return existing;
    const id =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : `lead_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(PENDING_KEY, id);
    return id;
  } catch (e) {
    return `lead_${Date.now()}`;
  }
};

/** Invia Lead + generate_lead una sola volta per eventId. */
export const sendLeadEvent = (eventId) => {
  const sent = read(SENT_KEY, []);
  if (!eventId || sent.includes(eventId)) return false;
  const ok = window.SCConsent ? window.SCConsent.trackLead(eventId) : false;
  try {
    localStorage.setItem(SENT_KEY, JSON.stringify([...sent, eventId].slice(-50)));
    localStorage.removeItem(PENDING_KEY);
  } catch (e) { /* noop */ }
  return ok;
};
